import HttpMethods from "../../../Services/httpMethods";
import { makeRequest } from "../../../Services/restcall";
import { ApiResponse } from "../../../Services/types";

export async function GetAllCategorysAPI(): Promise<ApiResponse> {
    return await makeRequest(HttpMethods.GET, '/api/commerce/categorys', {});
}